import './DataAccessCompareButton.scss';
import { Button } from 'antd';
import { getQueryString } from '@sonar-software/sonar-http';
import { useNavigate } from 'react-router';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
export const DataAccessCompareOption = ({ option }) => {
    const navigate = useNavigate();
    const handleCompareClick = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(`${FULL_ROUTES.DATA_SECURITY_DATA_ACCESS_ACCESS_COMPARE}?${getQueryString({
            accessType: option.type,
            accessTypeId: option.value
        })}`);
    }, [navigate, option]);
    return (React.createElement("div", { className: 'custom-option' },
        React.createElement("span", { className: 'option-label' }, option.label),
        React.createElement(Button, { className: 'compare-btn', onClick: handleCompareClick, onMouseDown: (e) => {
                e.preventDefault();
                e.stopPropagation();
            }, size: 'small', type: 'primary' }, COPY_SPECIFIC.COMPARE)));
};
